import * as React from "react";

import { IText } from "./classes/Text";

export interface IUnifiedPublishingNoAlertsDetail {
  text: IText;
}

export const UnifiedPublishingNoAlertsDetail = (props: IUnifiedPublishingNoAlertsDetail) => {
  return (
    <div className="A_alert A_expired">
      <div className="A_title">{props.text.noAlerts}</div>
      <div className="A_content">{props.text.noAlertsDescription}</div>
    </div>
  );
};
